import React, { FC } from 'react';
import { AddEntityWatcherButton } from '../../../watchers/components/add-entity-watcher/AddEntityWatcherButton';
import styles from './enterprise_follow.module.scss';
import { useRestrictedModal } from '../../../components/modal/useRestrictedModal';

const source = 'enterprise_page';

type Props = {
  enterpriseId: string;
  raisonSociale: string;
};

export const EnterpriseFollow: FC<Props> = ({
  raisonSociale,
  enterpriseId,
}) => {
  const { openRestrictedModal } = useRestrictedModal();
  return (
    <div className={styles.container} id="add-watcher-enterprise">
      <AddEntityWatcherButton
        queryParams={{ eid: enterpriseId, q: raisonSociale }}
        uniqueId={enterpriseId}
        restrict={() =>
          openRestrictedModal({ source: 'want_to_follow_enterprise' })
        }
        source={source}
      />
    </div>
  );
};
